module.exports = __webpack_public_path__ + "cecaeb808be30169b36cbd5f33f97c2c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-star-s.png
// module id = 1835
// module chunks = 0